import { render } from "./ListingPagination.vue?vue&type=template&id=09bc6882&ts=true"
import script from "./ListingPagination.vue?vue&type=script&lang=ts"
export * from "./ListingPagination.vue?vue&type=script&lang=ts"

import "./ListingPagination.vue?vue&type=style&index=0&id=09bc6882&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__